<template>
  <div name="stdapplinf-detail-pg1">
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-md-2 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['20'] }}</label>
          <div class="form-control readonly-field-color">{{ data.codtitle }} - {{ data.desc_codtitle }}</div>
        </div>
      </div>
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['30'] }}</label>
          <div class="form-control readonly-field-color">{{ data.nickname }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['40'] }}</label>
          <div class="form-control readonly-field-color">{{ data.ti_namfirst }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['50'] }}</label>
          <div class="form-control readonly-field-color">{{ data.ti_namlast }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['60'] }}</label>
          <div class="form-control readonly-field-color">{{ setDateOutput(data.dteappl) }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['70'] }} (1)</label>
          <div class="form-control readonly-field-color">{{ data.codpos1 }} - {{ data.ti_codpos1 }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['70'] }} (2)</label>
          <div class="form-control readonly-field-color">{{ data.codpos2 }} - {{ data.ti_codpos2 }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['80'] }}</label>
          <div class="radio">
            <label class="radio-inline">
                <input type="radio" value="Y" :checked="data.flgbrlc === 'Y' ? true : false" disabled>
                {{ labels['90'] }}
            </label>
            <label class="radio-inline">
                <input type="radio" value="N" :checked="data.flgbrlc === 'N' ? true : false" disabled>
                {{ labels['100'] }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['90'] }} (1)</label>
          <div class="form-control readonly-field-color">{{ data.codbrlc1 }} - {{ data.ti_codbrlc1 }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['90'] }} (2)</label>
          <div class="form-control readonly-field-color">{{ data.codbrlc2 }} - {{ data.ti_codbrlc2 }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['110'] }}</label>
          <div class="form-control readonly-field-color">{{ data.amtincfm }} - {{ data.amtincto }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['120'] }}</label>
          <div class="form-control readonly-field-color">{{ data.codcurr }} - {{ data.ti_codcurr }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['130'] }}</label>
          <div class="form-control readonly-field-color">{{ data.codmedia }} - {{ data.ti_codmedia }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['150'] }}</label>
          <div class="radio">
            <label class="radio">
                <input type="radio" value="Y" :checked="data.flgcar === 'Y' ? true : false" disabled>
                {{ labels['160'] }}
            </label>
            <div class="form-control readonly-field-color">{{ data.carlicid }}</div>
          </div>
          <div class="radio">
            <label class="radio">
                <input type="radio" value="N" :checked="data.flgcar === 'N' ? true : false" disabled>
                {{ labels['170'] }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['180'] }}</label>
          <div class="radio">
            <label class="radio-inline">
                <input type="radio" value="Y" :checked="data.flgwork === 'Y' ? true : false" disabled>
                {{ labels['190'] }}
            </label>
            <label class="radio-inline">
                <input type="radio" value="N" :checked="data.flgwork === 'N' ? true : false" disabled>
                {{ labels['200'] }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'stdapplinf-detail-pg1',
  props: [ 'labels', 'data' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>


// WEBPACK FOOTER //
// stdapplinfDetailPg1.vue?a718cede